const cwsTestimonials = () => {
  const testimonialsSlider = document.querySelector(".swiper--testimonials");
  if (!testimonialsSlider) {
    return;
  }

  const ensureSwiperLoaded = () => {
    if (typeof Swiper !== "undefined") {
      return Promise.resolve(Swiper);
    }

    if (window.__swiperLoaderPromise) {
      return window.__swiperLoaderPromise;
    }

    const swiperBundleUrl = window.themeAssets?.swiperBundleUrl;
    if (!swiperBundleUrl) {
      return Promise.reject(new Error("Missing Swiper bundle URL"));
    }

    window.__swiperLoaderPromise = new Promise((resolve, reject) => {
      const existingScript = document.querySelector(
        `script[src="${swiperBundleUrl}"]`
      );

      if (existingScript) {
        if (typeof Swiper !== "undefined") {
          resolve(Swiper);
          return;
        }
        existingScript.addEventListener("load", () => resolve(Swiper), {
          once: true,
        });
        existingScript.addEventListener("error", reject, { once: true });
        return;
      }

      const script = document.createElement("script");
      script.src = swiperBundleUrl;
      script.defer = true;
      script.onload = () => resolve(Swiper);
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return window.__swiperLoaderPromise;
  };

  ensureSwiperLoaded()
    .then(() => {
      new Swiper(".swiper--testimonials", {
        slidesPerView: 1,
        spaceBetween: 32,
        autoHeight: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            autoHeight: false,
            spaceBetween: 20,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 20,
            autoHeight: false,
            slidesPerGroup: 3,
          },
        },
      });
    })
    .catch(console.error);
};

const vwsMinHeight = () => {
  const titles = document.querySelectorAll(".testimonial h3");
  const calcMinHeight = () => {
    titles.forEach((title) => {
      title.style.minHeight = "";

      if (title.clientHeight > height) {
        height = title.clientHeight;
      }
    });

    titles.forEach((title) => {
      if (window.screen.width > 768) {
        title.style.minHeight = `${height}px`;
      } else {
        title.style.minHeight = "";
      }
    });
  };
  let height = 0;

  calcMinHeight();

  window.addEventListener("resize", () => {
    height = 0;
    calcMinHeight();
  });
};

document.addEventListener("DOMContentLoaded", () => {
  cwsTestimonials();
  vwsMinHeight();
});
